import { useLayoutEffect, useState, type MutableRefObject } from 'react';

export interface UseScrollToCurrentWeekProps {
  ref: MutableRefObject<HTMLElement>;
  hasLoaded: boolean;
}

const useScrollToCurrentWeek = (props: UseScrollToCurrentWeekProps) => {
  const { ref, hasLoaded } = props;

  const [offsetTop, setOffsetTop] = useState<number>();

  useLayoutEffect(() => {
    if (!hasLoaded || !ref.current) {
      return;
    }

    const top = ref.current.offsetTop;

    // For reasons unknown, typescript errors on the 'instant' behaviour,
    // even though it is available. So we ignore it for now.
    // @ts-ignore
    window.scrollTo({ top, behavior: 'instant' });
    setOffsetTop(top);

  // We only want to scroll to the current week on initial load,
  // not every time the ref changes. That's why we disable this linting rule.
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [hasLoaded]);

  return offsetTop;
};

export default useScrollToCurrentWeek;
